export default function (cli) {
  return {
    login (username, password) {
      return cli.post(`${cli.apiEndpointV2}auth/`).send({username, password})
    },
    staffLogin (code, password) {
      return cli.post(`${cli.apiEndpoint}auth/staff-login/`).send({code, password})
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js